export default __webpack_public_path__ + "static/media/p8.71d6f805.png";